import { gql } from "@apollo/client";
import { client } from "api";
import {
  GET_DJ_COURSE_DETAILS_QUERY,
  GET_PRECONTRACT_COURSE_DETAILS_QUERY,
} from "../course";
import { DocumentType } from "interfaces";

interface MutationParams {
  params: {
    documentId: number;
    comment: string;
  };
}
interface RefetchParams {
  params: {
    sencenet: string;
    documentType: DocumentType;
  };
}
interface MutationResult {
  forceDocumentValidation: boolean | null;
}

export const forceDocumentValidation = async (
  params: MutationParams["params"],
  refetchParams: RefetchParams["params"],
  documentType: DocumentType,
): Promise<boolean | null> => {
  if (!params.documentId) return false;
  const response = await client.mutate<MutationResult, MutationParams>({
    mutation: gql`
      mutation ForceDocumentValidation(
        $params: ForceDocumentValidationParams!
      ) {
        forceDocumentValidation(params: $params)
      }
    `,
    variables: {
      params,
    },
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query:
          documentType === DocumentType.PRECONTRACT
            ? GET_PRECONTRACT_COURSE_DETAILS_QUERY(documentType)
            : GET_DJ_COURSE_DETAILS_QUERY(documentType, refetchParams.sencenet),
        variables: {
          params: refetchParams,
        },
      },
    ],
  });
  return !!response.data?.forceDocumentValidation;
};
